import { Box, Typography, Grid } from "@mui/joy";
import { TextField, Textarea } from "../../../../../shared";
import { LogoUploadField } from "../../LogoUploadField";

export function ProfileSettings() {
    return (
        <Box display="flex" flexDirection="column" gap={1.5} maxWidth={640}>
            <Box mb={0.5}>
                <Typography level="title-md" sx={{ fontWeight: 700 }}>
                    Profile
                </Typography>
                <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                    Tenant identity shown across the platform and on contract documents.
                </Typography>
            </Box>

            <LogoUploadField />

            <TextField
                name="Name"
                label="Organization Name"
                helperText="Enter the name of the organization"
                placeholder="e.g., Colorado Roofing Company"
            />

            <TextField
                name="ShortName"
                label="Short Name"
                helperText="Optional short name or abbreviation"
                placeholder="e.g., CRC"
            />

            <Textarea
                name="Description"
                label="Description"
                helperText="Optional summary of the organization"
                placeholder="e.g., Regional roofing contractor serving Colorado homeowners"
                minRows={3}
            />

            <Grid container spacing={2}>
                <Grid xs={12}>
                    <TextField
                        name="Website"
                        label="Website"
                        helperText="Optional organization website"
                        placeholder="e.g., https://www.example.com"
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
